import NavBar from "../general/navBar";
import Footer from "../main/footer";

const PolitiqueConf = () => {
  return (
    <section className="pc-section" id="mentions">
      <NavBar />
      <div class="container">
        <div class="service-details__right">
          <div class="service-details__content">
            <h1 class="service-details__content-title">Mentions Légales</h1>
            <p class="service-details__text-1">
              La connexion et la navigation sur le Site par l’Utilisateur
              implique acceptation intégrale et sans réserve des présentes
              mentions légales.
              <br />
              Ces dernières sont accessibles sur le site{" "}
              <strong>www.lexicredis.com</strong> à la rubrique « Mentions
              légales ».
            </p>

            {/* <!-- ################################### -->
								<!-- Article 1 Start --> */}
            <h2 class="service-details__text-2">1. Présentation du site</h2>
            <p class="service-details__text-3">
              En vertu de l’article 6 de la loi n° 2004-575 du 21 juin 2004 pour
              la confiance dans l’économie numérique, dite L.C.E.N., il est
              précisé aux utilisateurs et aux visiteurs, ci-après nommés
              "utilisateurs" du site <strong>www.lexicredis.com</strong>{" "}
              l’identité des différents intervenants dans le cadre de sa
              réalisation et de son suivi:
              <ul>
                <li>
                  &bull;&nbsp;SARL LexiCredis. au capital de 1000€, immatriculé au RCS de
                  Nice, sous le SIREN : 793082397 et situé: 8 AVENUE NOTRE-DAME,
                  06000 NICE
                </li>
                <li>
                  &bull;&nbsp;Responsable publication: Jennifer Gerbi
                  </li>
                <li>
                  &bull;&nbsp;Hébergeur: SARL MaelCorp au capital de 1000€, situé: 35 rue
                  pastorelli
                </li>
              </ul>
            </p>
            {/* <!-- Article 1 Start -->
								<!-- ################################### -->
								<!-- Article 2 Start --> */}
            <h2 class="service-details__text-2">2. Informations nominatives</h2>
            <p class="service-details__text-3">
              Conformément à la réglementation applicable (Loi n° 1.165, du 23
              décembre 1993, modifiée) en matière de protection des informations
              nominatives vous concernant, vous disposez d’un droit individuel
              d’opposition, d’accès et de rectification. Vous pouvez exercer ces
              droits en adressant votre demande, en ligne via{" "}
              <a href="../contact/">cette page</a> ou par courrier postal
              adressé à l’adresse présentée dans l'article précédent.
            </p>
            {/* <!-- Article 2 End -->
								<!-- ################################### -->
								<!-- Article 3 Start --> */}
            <h2 class="service-details__text-2">
              3. Conditions générales d’utilisation du site et des services
              proposés
            </h2>
            <p class="service-details__text-3">
              L’utilisation du site <strong>www.lexicredis.com</strong> implique
              l’acceptation pleine et entière des conditions générales
              d’utilisation ci-après décrites. Ces conditions d’utilisation sont
              susceptibles d’être modifiées ou complétées à tout moment, les
              utilisateurs du site <strong>www.lexicredis.com</strong> sont donc
              invités à les consulter de manière régulière.
            </p>
            <p class="service-details__text-3">
              Ce site est normalement accessible à tout moment aux utilisateurs.
              <br />
              Une interruption pour raison de maintenance technique peut être
              toutefois décidée par l’équipe, qui s’efforcera alors de
              communiquer préalablement aux utilisateurs les dates et heures de
              l’intervention.
            </p>
            <p class="service-details__text-3">
              Le site <strong>www.lexicredis.com</strong> est mis à jour
              régulièrement. De la même façon, les mentions légales peuvent être
              modifiées à tout moment: elles imposent néanmoins à l’utilisateur
              qui est invité à s’y référer le plus souvent possible afin d’en
              prendre connaissance.
            </p>
            {/* <!-- Article 3 End -->
								<!-- ################################### -->
								<!-- Article 4 Start --> */}
            <h2 class="service-details__text-2">
              4. Description des services fournis
            </h2>
            <p class="service-details__text-3">
              Le site <strong>www.lexicredis.com</strong> a pour objet de
              fournir une information concernant l’ensemble des activités de
              l'entreprise.
            </p>
            <p class="service-details__text-3">
              L'entreprise "LexiCredis." s’efforce d’y fournir des informations
              aussi précises que possible.
              <br />
              Toutefois, elle ne pourra être tenue responsable des omissions,
              des inexactitudes et des carences dans la mise à jour, qu’elles
              soient de son fait ou du fait des tiers partenaires qui lui
              fournissent ces informations.
            </p>
            <p class="service-details__text-3">
              Toutes les informations indiquées sur le site{" "}
              <strong>www.lexicredis.com</strong> sont données à titre
              indicatif, et sont susceptibles d’évoluer. Par ailleurs, les
              renseignements figurant sur le site{" "}
              <strong>www.lexicredis.com</strong> ne sont pas exhaustifs. Ils
              sont donnés sous réserve de modifications ayant été apportées
              depuis leur mise en ligne.
            </p>
            {/* <!-- Article 4 End -->
								<!-- ################################### -->
								<!-- Article 5 Start --> */}
            <h2 class="service-details__text-2">
              5. Limitations contractuelles sur les données techniques
            </h2>
            <p class="service-details__text-3">
              Le site utilise la technologie JavaScript. Le site Internet ne
              pourra être tenu responsable de dommages matériels liés à
              l’utilisation du site. De plus, l’utilisateur du site s’engage à
              accéder au site en utilisant un matériel récent, ne contenant pas
              de virus et avec un navigateur de dernière génération mis à jour.
            </p>
            {/* <!-- Article 5 End -->
								<!-- ################################### -->
								<!-- Article 6 Start --> */}
            <h2 class="service-details__text-2">
              6. Propriété intellectuelle et contrefaçons
            </h2>
            <p class="service-details__text-3">
              L'entreprise "LexiCredis." est propriétaire des droits de
              propriété intellectuelle ou détient les droits d’usage sur tous
              les éléments accessibles sur le site, notamment les textes,
              images, graphismes, icônes, logiciels.
              <br />
              Par ailleurs, plusieurs images libres de droit proviennent du site
              Pexels, et sont des images libre de droits.
            </p>
            <p class="service-details__text-3">
              Toute reproduction, représentation, modification, publication,
              adaptation de tout ou partie des éléments du site, quel que soit
              le moyen ou le procédé utilisé, est interdite, sauf autorisation
              écrite préalable de l'entreprise "LexiCredis.".
            </p>
            <p class="service-details__text-3">
              Toute exploitation non autorisée du site ou de l’un des éléments
              qu’il contient sera considérée comme constitutive d’une
              contrefaçon et poursuivie conformément aux dispositions des
              articles L.335-2 et suivants du Code de Propriété Intellectuelle.
            </p>
            {/* <!-- Article 6 End -->
								<!-- ################################### -->
								<!-- Article 7 Start --> */}
            <h2 class="service-details__text-2">
              7. Limitations de responsabilité
            </h2>
            <p class="service-details__text-3">
              L'entreprise "LexiCredis." ne pourra être tenue responsable des
              dommages directs et indirects causés au matériel de l’utilisateur,
              lors de l’accès au site <strong>www.lexicredis.com</strong>, et
              résultant soit de l’utilisation d’un matériel ne répondant pas aux
              spécifications indiquées au point 4, soit de l’apparition d’un bug
              ou d’une incompatibilité.
            </p>
            <p class="service-details__text-3">
              L'entreprise "LexiCredis." ne pourra également être tenue
              responsable des dommages indirects (tels par exemple qu’une perte
              de marché ou perte d’une chance) consécutifs à l’utilisation du
              site <strong>www.lexicredis.com</strong>.
            </p>
            <p class="service-details__text-3">
              Des espaces interactifs (possibilité de poser des questions dans
              l’espace contact) sont à la disposition des utilisateurs.
            </p>
            <p class="service-details__text-3">
              L'entreprise "LexiCredis." se réserve le droit de supprimer, sans
              mise en demeure préalable, tout contenu déposé dans cet espace qui
              contreviendrait à la législation applicable en France, en
              particulier aux dispositions relatives à la protection des
              données.
            </p>
            <p class="service-details__text-3">
              Le cas échéant, l'entreprise "LexiCredis." se réserve également la
              possibilité de mettre en cause la responsabilité civile et/ou
              pénale de l’utilisateur, notamment en cas de message à caractère
              raciste, injurieux, diffamant, ou pornographique, quel que soit le
              support utilisé.
            </p>
            {/* <!-- Article 7 End -->
								<!-- ################################### -->
								<!-- Article 8 Start --> */}
            <h2 class="service-details__text-2">
              8. Gestion des données personnelles
            </h2>
            <p class="service-details__text-3">
              En France, les données personnelles sont notamment protégées par
              la loi n° 78-87 du 6 janvier 1978, la loi n° 2004-801 du 6 août
              2004, l’article L. 226-13 du Code pénal et la Directive Européenne
              du 24 octobre 1995.
            </p>
            <p class="service-details__text-3">
              A l’occasion de l’utilisation du site{" "}
              <strong>www.lexicredis.com</strong>, peuvent être recueillies:
              l’URL des liens par l’intermédiaire desquels l’utilisateur a
              accédé au site, le fournisseur d’accès de l’utilisateur, l’adresse
              de protocole Internet (IP) de l’utilisateur.
            </p>
            <p class="service-details__text-3">
              En tout état de cause l'entreprise "LexiCredis." ne collecte des
              informations personnelles relatives à l’utilisateur que pour le
              besoin de certains services proposés par le site.
            </p>

            <p class="service-details__text-3">
              L’utilisateur fournit ces informations en toute connaissance de
              cause, notamment lorsqu’il procède par lui-même à leur saisie. Il
              est alors précisé à l’utilisateur du site l’obligation ou non de
              fournir ces informations.
            </p>

            <p class="service-details__text-3">
              Conformément aux dispositions des articles 38 et suivants de la
              loi 78-17 du 6 janvier 1978 relative à l’informatique, aux
              fichiers et aux libertés, tout utilisateur dispose d’un droit
              d’accès, de rectification et d’opposition aux données personnelles
              le concernant, en effectuant sa demande écrite et signée,
              accompagnée d’une copie du titre d’identité avec signature du
              titulaire de la pièce, en précisant l’adresse à laquelle la
              réponse doit être envoyée.
            </p>

            <p class="service-details__text-3">
              Aucune information personnelle de l’utilisateur du site{" "}
              <strong>www.lexicredis.com</strong> n’est publiée à l’insu de
              l’utilisateur, échangée, transférée, cédée ou vendue sur un
              support quelconque à des tiers.
            </p>
            <p class="service-details__text-3">
              Seule l’hypothèse du rachat de l'entreprise "LexiCredis." et de
              ses droits permettrait la transmission des dites informations à
              l’éventuel acquéreur qui serait à son tour tenu de la même
              obligation de conservation et de modification des données
              vis-à-vis de l’utilisateur du site.
            </p>
            {/* <!-- Article 8 End -->
								<!-- ################################### -->
								<!-- Article 9 Start --> */}
            <h2 class="service-details__text-2">
              9. Liens hypertextes et cookies
            </h2>
            <p class="service-details__text-3">
              La navigation sur le site <strong>www.lexicredis.com</strong> est
              susceptible de provoquer l’installation de cookie(s) sur
              l’ordinateur de l’utilisateur. Un cookie est un fichier de petite
              taille, qui ne permet pas l’identification de l’utilisateur, mais
              qui enregistre des informations relatives à la navigation d’un
              ordinateur sur un site.
            </p>
            <p class="service-details__text-3">
              Les données ainsi obtenues visent à faciliter la navigation
              ultérieure sur le site, et ont également vocation à permettre
              diverses mesures de fréquentation. Le refus d’installation d’un
              cookie peut entraîner l’impossibilité d’accéder à certains
              services.
            </p>
            <p class="service-details__text-3">
              L’utilisateur peut toutefois configurer son ordinateur de la
              manière suivante, pour refuser l’installation des cookies:
              <ul>
                <ul class="list-unstyle">
                  <li class="maelcorp-underline">Sous Internet Explorer:</li>
                  <li>
                    Onglet outil (pictogramme en forme de rouage en haut à
                    droite) / options internet. Cliquez sur Confidentialité et
                    choisissez Bloquer tous les cookies. Validez sur Ok.
                  </li>
                </ul>
                <ul class="list-unstyle">
                  <li class="maelcorp-underline">Sous Firefox:</li>
                  <li>
                    En haut de la fenêtre du navigateur, cliquez sur le bouton
                    Firefox, puis allez dans l’onglet Options. Cliquez sur
                    l’onglet Vie privée. Paramétrez les Règles de conservation
                    sur: utiliser les paramètres personnalisés pour
                    l’historique. Enfin décochez-la pour désactiver les cookies.
                  </li>
                </ul>
                <ul class="list-unstyle">
                  <li class="maelcorp-underline">Sous Safari:</li>
                  <li>
                    Cliquez en haut à droite du navigateur sur le pictogramme de
                    menu (symbolisé par un rouage). Sélectionnez Paramètres.
                    Cliquez sur Afficher les paramètres avancés. Dans la section
                    « Confidentialité », cliquez sur Paramètres de contenu. Dans
                    la section « Cookies », vous pouvez bloquer les cookies.
                  </li>
                </ul>
                <ul class="list-unstyle">
                  <li class="maelcorp-underline">Sous Chrome:</li>
                  <li>
                    Cliquez en haut à droite du navigateur sur le pictogramme de
                    menu (symbolisé par trois lignes horizontales). Sélectionnez
                    Paramètres. Cliquez sur Afficher les paramètres avancés.
                    Dans la section « Confidentialité », cliquez sur
                    préférences. Dans l’onglet « Confidentialité », vous pouvez
                    bloquer les cookies.
                  </li>
                </ul>
              </ul>
            </p>
            {/* <!-- Article 6 End -->
								<!-- ################################### --> */}
          </div>
        </div>
      </div>
      <Footer />
    </section>
  );
};

export default PolitiqueConf;
